export default __webpack_public_path__ + "static/media/work__card-icon-3.b70f579e.svg";